module.exports = __webpack_public_path__ + "img/pennsylvania-anti-slavery-society.1cf62c38.png";